import { GoogleSignin } from '@react-native-google-signin/google-signin';
import { logoutCustomerIO } from 'app/hooks/customerIO';
import { recordError } from 'app/lib/monitoring';
import { pushNotifRegistrationInstance } from 'app/lib/push-notifications';
import { storage, StorageKey } from 'app/lib/storage';
import { signOut as CognitoSignOut } from 'aws-amplify/auth';
import type { AxiosInstance } from 'axios';
import { getAuthenticationApiBaseUrl } from 'app/lib/axios/api-endpoint';

export async function deleteIdentity(
  http: AxiosInstance,
  tokens?: { refreshToken: string | null; accessToken: string | null },
  options?: { skipPushUnregistration?: boolean },
) {
  const logoutGoogle = async () => {
    try {
      await GoogleSignin.signOut();
    } catch (error) {
      recordError(error);
    }
  };

  const logoutAmazon = async () => {
    try {
      await CognitoSignOut();
    } catch (error) {
      recordError(error);
    }
  };

  const deleteToken = async () => {
    const [refreshToken, accessToken] = tokens
      ? [tokens.refreshToken, tokens.accessToken]
      : await Promise.all([storage.readString(StorageKey.RefreshToken), storage.readString(StorageKey.AccessToken)]);
    if (refreshToken) {
      await http
        .delete<null>(`/authentication/${refreshToken}`, {
          timeout: 10_000,
          baseURL: getAuthenticationApiBaseUrl(accessToken),
          lpcApiEndpoint: {
            allowFallback: false,
            attemptedBaseUrls: [],
            originalData: undefined,
            preservePreferredEndpoint: true,
          },
        })
        .catch(recordError);
    }
  };

  void logoutAmazon();
  void logoutGoogle();

  // Unregister while the current session is still available to the request interceptor.
  if (!options?.skipPushUnregistration) {
    await pushNotifRegistrationInstance(http).unregisterFromRemoteNotifications();
  }
  logoutCustomerIO();

  await deleteToken();
}
